export const SAVE_IN_PROGRESS = 'SAVE_IN_PROGRESS';
export const SAVE_PROCESS_DONE = 'SAVE_PROCESS_DONE';
